"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * AudioProfile defines quality settings of the audio input
 * device. Use the static methods to create presets optimized
 * for fullband speech and fullband music with a mono channel.
 */

var AudioProfile = /*#__PURE__*/function () {
  /**
   * Constructs an AudioProfile given an audio bitrate. If no
   * audio bitrate is supplied, then the default AudioProfile
   * is constructed. The default AudioProfile does not adjust
   * the browser's internal bitrate setting.
   */
  function AudioProfile() {
    var audioBitrateBps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, AudioProfile);

    this.audioBitrateBps = audioBitrateBps;
  }
  /**
   * Creates an AudioProfile optimized for fullband speech (40 kbit/s mono).
   */


  _createClass(AudioProfile, [{
    key: "isStereo",
    value:
    /**
     * Returns true if audio profile is set to stereo mode.
     */
    function isStereo() {
      return this.audioBitrateBps === 128000;
    }
  }], [{
    key: "fullbandSpeechMono",
    value: function fullbandSpeechMono() {
      return new AudioProfile(40000);
    }
    /**
     * Creates an AudioProfile optimized for fullband music (64 kbit/s mono).
     */

  }, {
    key: "fullbandMusicMono",
    value: function fullbandMusicMono() {
      return new AudioProfile(64000);
    }
    /**
     * Creates an AudioProfile optimized for fullband stereo music (128 kbit/s stereo).
     */

  }, {
    key: "fullbandMusicStereo",
    value: function fullbandMusicStereo() {
      return new AudioProfile(128000);
    }
  }]);

  return AudioProfile;
}();

exports.default = AudioProfile;